const INVALID_VALUES = [null, undefined, ""];

export const isValidData = (data) => {
  return !INVALID_VALUES.includes(data);
};
